import React, { memo, useCallback, useMemo } from 'react';
import { QuickFilters } from '@Sage/ssm-web5';

import { getLiteral } from 'utils/getLiteral';

const FILTER_IDS = ['businessType'];

const LeadsQuickFilters = ({
    category,
    categoryOptions,
    businessTypesLoading,
    businessTypesError,
    onChangeCategory,
}) => {
    const schema = useMemo(
        () => [
            {
                id: 'businessType',
                label: getLiteral('label_leads_business_type'),
                isRemovable: false,
                fields: [
                    {
                        id: 'businessType',
                        label: getLiteral('label_leads_business_type'),
                        dataType: 'singleValueList',
                        inputProps: {
                            options: categoryOptions,
                            isClearable: false,
                            isDisabled: Boolean(businessTypesLoading || businessTypesError),
                        },
                    },
                ],
            },
        ],
        [businessTypesError, businessTypesLoading, categoryOptions],
    );

    const values = useMemo(
        () => ({
            businessType: categoryOptions.find((item) => item.value === category),
        }),
        [category, categoryOptions],
    );

    const handleChange = useCallback(
        ({ filter, value }) => {
            if (filter.id === 'businessType') onChangeCategory(value?.value ?? '');
        },
        [onChangeCategory],
    );

    return (
        <QuickFilters
            className="fm-leads-modal__quick-filters"
            filters={FILTER_IDS}
            schema={schema}
            values={values}
            onChange={handleChange}
            showAdd={false}
        />
    );
};

export default memo(LeadsQuickFilters);
